import { Col, Row } from "antd";
import React, { useRef, useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaImage } from "react-icons/fa";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import styles from "./newAdds.module.css";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AdvertisementMiddleware } from "../../../../Store/Middlewares/AdvertisementMiddleware";
import { useNavigate } from "react-router-dom";

const NewAdds = () => {
  const [type, setType] = useState("Text & Pictorial");
  const [img, setImg] = useState(null);
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  // console.log("type", type);
  const imgRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);
  const onCreateAdd = () => {
    if (!user?.is_subscribed) {
      showAlert({
        type: "Error",
        message: "Please subscribe to create adds",
      });
    } else if (!title || !img || (type == "Text & Pictorial" && !note)) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory.",
        })
      );
    } else {
      let data = {
        title: title,
        type: type,
        text: type == "Text & Pictorial" ? note : null,
        document: img,
      };
      dispatch(AdvertisementMiddleware.createAdvertisement(data))
    }
  };
  return (
    <>
      <Row className={styles.mainCont}>
        <Col className={styles.col}>
          <InputField
            label="Title"
            placeholder={"Photography Services"}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <DropDown
            placeholder={"Text & Pictorial"}
            label={"Ad Type"}
            selectedValue={type}
            onChange={setType}
            options={[
              { value: "Text & Pictorial", option: "Text & Pictorial" },
              { value: "Pictorial", option: "Pictorial" },
            ]}
          />
          {type == "Text & Pictorial" && (
            <TextareaField
              label={"Add Note"}
              placeholder="Please Enter Note "
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          )}
        </Col>

        <Col className={styles.col}>
          {/* <Row className={styles.imgCont}>
          <FaCamera color="#C6C6C6" size={70} />
          <TextCompon
          ent text="Take A Photo" textClass={styles.text} />
        </Row> */}

          {/* {type == "Text & Pictorial" && ( */}
          <>
            {img ? (
              <>
                <Row className={styles.crossIcon}>
                  <CgClose
                    size={25}
                    color="var(--primary-color)"
                    onClick={() => setImg(null)}
                    cursor={"pointer"}
                  />
                </Row>
                <Row className={styles.imgCont}>
                  <img src={img && URL.createObjectURL(img)} alt="" />
                </Row>
              </>
            ) : (
              <Row
                className={styles.selimgCont}
                onClick={() => imgRef.current.click()}
              >
                <FaImage color="#C6C6C6" size={70} />
                <TextComponent text="Upload an Image" textClass={styles.text} />
              </Row>
            )}
          </>
          {/* )} */}
        </Col>

        <input
          type="file"
          accept=".jpg,.png,.gif,.jpeg"
          // multiple
          onChange={(e) => {
            setImg(e.target.files[0]);
            imgRef.current.value = "";
          }}
          ref={imgRef}
          className={styles.displayNone}
        />
      </Row>
      <SubmitButton title="Add" btnClass={styles.btn} onClick={onCreateAdd} />
    </>
  );
};

export default NewAdds;
